/**
 * Copyright (C) 2026 Checkmk GmbH - License: GNU General Public License v2
 * This file is part of Checkmk (https://checkmk.com). It is subject to the terms and
 * conditions defined in the file COPYING, which is part of this source code package.
 */

/**
 * Event name dispatched when a sidebar snapin needs to refresh its content
 */
export const SIDEBAR_UPDATE_SNAPIN_CONTENT_EVENT = 'sidebar-update-snapin-content'
